import { lazy, Suspense } from 'react'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { selectUser, selectAuthStatus } from '../../../selectors/users'
import { useLogoutMutation } from '../../../services/auth_endpoints'
import { Footer } from '../footer'
import IconButton from '../../shared/icon_button'
import { LanguageSwitcher } from '../../shared/language_switcher'
import { ImpersonationBanner } from '../../shared/impersonation_banner'
import { ASSETS_URL, WHITE_LOGO_URL } from '../../../assets_config'
import SimpleBar from 'simplebar-react'

const LoggedOutDropdown = lazy(() => import('./logged_out_dropdown').then(m => ({ default: m.LoggedOutDropdown })))
const LoggedInDropdown = lazy(() => import('./logged_in_dropdown').then(m => ({ default: m.LoggedInDropdown })))
const HamburgerDropdown = lazy(() => import('./hamburger_dropdown').then(m => ({ default: m.HamburgerDropdown })))

export const HomeHeader = ({ children }) => {
  const { t } = useTranslation()
  const user = useSelector(selectUser)
  const authStatus = useSelector(selectAuthStatus)

  const [logout] = useLogoutMutation()

  const handleLogout = async (event) => {
    event.preventDefault()
    await logout()
    window.location.href = '/'
  }

  return (
    <SimpleBar style={{ maxHeight: '100vh' }}>
      <ImpersonationBanner />
      <Container className="home-header-container" fluid>
        <Container className="header-background" fluid>
          <img
            src={`${ASSETS_URL}/images/header-bg.webp`}
            srcSet={`${ASSETS_URL}/images/header-bg-mobile.webp 828w, ${ASSETS_URL}/images/header-bg.webp 1792w`}
            sizes="(max-width: 828px) 828px, 1792px"
            alt=""
            aria-hidden="true"
            fetchpriority="high"
            className="header-bg-img"
          />
          <Row className="padding-top-1">

            <Col md={4} xs={4} className="center-content-v">
              <div className="left-content margin-left-1 inline-flex-container">
                <Suspense fallback={<div style={{ width: 40, height: 40 }} />}>
                  <HamburgerDropdown />
                </Suspense>
                <LanguageSwitcher />
              </div>
            </Col>

            <Col md={4} xs={4} className="center-content">
              <a className="header-link" href="/">
                <img
                  alt="top-spin-logo"
                  src={WHITE_LOGO_URL}
                  className="big-logo"
                  fetchpriority="high"
                  width={120}
                  height={40}
                />
              </a>
            </Col>

            <Col md={{ span: 1, offset: 3 }} xs={4} className="center-content-v">
              <div className="right-content margin-right-1">
                <Suspense fallback={<div style={{ width: 40, height: 40 }} />}>
                  {authStatus === 'authenticated' && <LoggedInDropdown user={user} handleLogout={handleLogout} />}
                  {authStatus === 'anonymous' && <LoggedOutDropdown />}
                  {authStatus === 'loading' && (
                    // /me still in flight: stable neutral icon, no logged-out flash.
                    <IconButton icon='user' width={36} height={36} tooltip={t('userMenu.accountMenuTooltip')} disabled />
                  )}
                </Suspense>
              </div>
            </Col>

          </Row>
          <Row className="bottom-header-row">
            <Col md={4} xs={12} className="xxl-text bold white margin-left-1">
              <h1>
                {t('homeHeader.heroTitle')}
              </h1>
            </Col>
            <Col md={{ span: 4, offset: 3 }} xs={12}>
              {authStatus === 'authenticated' ?
                <Button
                  className="home-sign-up-button xl-text extra-bold pull-right"
                  href="/homepage/create_event"
                >
                  {t('homeHeader.createTournament')}
                </Button>
                : (
                <Button
                  className="home-sign-up-button xl-text extra-bold pull-right"
                  href="/register"
                >
                  {t('homeHeader.signUpNow')}
                </Button>
              )}
            </Col>
          </Row>
        </Container>
      </Container>

      {children}
      <Footer />
    </SimpleBar>
  )
}